import clsx from 'clsx';

type TermsPropsT = {
  children: React.ReactNode;
  className?: string;
  title?: string;
};

function Terms({children, className, title}: TermsPropsT) {
  return (
    <div
      className={clsx(
        'scrollbar-inverted flex max-h-80 flex-col gap-4 overflow-y-auto rounded-[0.25rem] border border-gray-200 bg-white/80 p-4 text-gray-800',
        className
      )}
    >
      {title && <h1 className="underline underline-offset-2">{title}</h1>}
      {children}
    </div>
  );
}

export default Terms;
